import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { Alert } from '../../components/widgets';
import { SECTION_ACCESS_TYPES } from '../../utils/consts';
import { translationPrefix } from '../utils';
import css from './SectionsPageStep.css';
import SectionsStepCard from './SectionsStepCard';

const SectionsPageStep = ({ allSectionPermissions, allSections, onToggleAccessType, cards, step }) => {
    const allSectionNames = useMemo(() => cards.flatMap(card => card.parts.flatMap(part => part.sectionNames)), [
        cards,
    ]);
    const hasViewAccess = useMemo(
        () =>
            allSectionPermissions.some(
                permission =>
                    allSectionNames.includes(permission.name) && permission.access_type === SECTION_ACCESS_TYPES.VIEW
            ),
        [allSectionPermissions, allSectionNames]
    );

    const renderCard = ({ title, description, parts }) => {
        const sectionNames = parts.flatMap(part => part.sectionNames);
        const sections = allSections.filter(section => sectionNames.includes(section.name));
        const sectionPermissions = allSectionPermissions.filter(permission => sectionNames.includes(permission.name));

        return (
            <SectionsStepCard
                title={title}
                description={description}
                sections={sections}
                parts={parts}
                sectionPermissions={sectionPermissions}
                onToggleAccessType={onToggleAccessType}
                step={step}
            />
        );
    };

    return (
        <div className={css.container}>
            {cards.map(renderCard)}
            {hasViewAccess && (
                <Alert
                    className={css.alert}
                    alertIconClassName={css.alertIcon}
                    type="warning"
                    text={`${translationPrefix}.MANAGE_PERMISSIONS_PAGE.${step.toUpperCase()}.VIEW_ACCESS_DESCRIPTION`}
                />
            )}
        </div>
    );
};

SectionsPageStep.propTypes = {
    step: PropTypes.string.isRequired,
    cards: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            description: PropTypes.string.isRequired,
            parts: PropTypes.arrayOf(
                PropTypes.shape({
                    displayName: PropTypes.string,
                    page: PropTypes.shape({
                        link: PropTypes.string.isRequired,
                        translationKey: PropTypes.string.isRequired,
                    }),
                    sectionNames: PropTypes.arrayOf(PropTypes.string).isRequired,
                    tooltipImageSrc: PropTypes.string,
                    tooltipDescriptionSectionName: PropTypes.string,
                })
            ).isRequired,
        })
    ).isRequired,
    allSectionPermissions: PropTypes.arrayOf(
        PropTypes.shape({
            access_type: PropTypes.number.isRequired,
            display_name: PropTypes.string.isRequired,
            feature_name: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            ui_key: PropTypes.string.isRequired,
        })
    ).isRequired,
    allSections: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            display_name: PropTypes.string.isRequired,
            feature_name: PropTypes.string.isRequired,
        })
    ).isRequired,
    onToggleAccessType: PropTypes.func.isRequired,
};

export default SectionsPageStep;
